import _ from "lodash";
import LOG from "services/loggingService";
import audioUtils from "util/audioUtils";
import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";

const ininAudioUtils = {
    recommendedAudioFormat: null,
    acceptedAudioFormats: null,

    mimeTypes: [
        { mimeType: "audio/mpeg", formatId: "mp3", native: true },
        { mimeType: "audio/webm", formatId: "webm", native: true },
        { mimeType: "audio/wav", formatId: "wav", native: true },
    ],

    mimeTypesV2: [
        { mimeType: "audio/mpeg", formatId: "mp3", native: true },
        { mimeType: "audio/webm", formatId: "webm", native: true },
        { mimeType: "audio/wav", formatId: "wav", native: true },
        { mimeType: "audio/ogg", formatId: "ogg_opus", native: true },
    ],

    probeNativeAudioSupport: function (force) {
        if (this.recommendedAudioFormat && !force) {
            return this.recommendedAudioFormat;
        }

        const audioElement = document.createElement("audio");
        let supportedType = null;

        if (audioElement) {
            supportedType = _.find(this.mimeTypes, function (c) {
                if (
                    audioElement.canPlayType &&
                    audioElement.canPlayType(c.mimeType)
                ) {
                    LOG.info(
                        "Client can natively play " +
                            c.mimeType +
                            ", formatId=" +
                            c.formatId
                    );
                    return c;
                }
            });
        }

        //Fallback to wav if nothing else works
        if (!supportedType) {
            const c = { mimeType: "audio/wav", formatId: "wav", native: false };
            LOG.info(
                "No natively playable mimeTypes found, using " +
                    c.mimeType +
                    ", formatId=" +
                    c.formatId
            );
            supportedType = c;
        }

        this.recommendedAudioFormat = supportedType;

        return supportedType;
    },

    probeNativeAudioSupportV2: function (force) {
        if (this.acceptedAudioFormats && !force) {
            return this.acceptedAudioFormats;
        }

        const audioElement = document.createElement("audio");
        const supportedFormats = [];

        if (audioElement) {
            const isOggSupportFTEnabled = featureToggleService.isEnabled(
                FeatureToggle.REC_7506_CHECK_FOR_OGG_SUPPORT_FT
            );
            this.mimeTypesV2.forEach((c) => {
                if (
                    isOggSupportFTEnabled &&
                    c.mimeType === "audio/ogg" &&
                    !audioUtils.isOggOpusSupported
                ) {
                    LOG.info(
                        "The browser does not support ogg opus files, hence skipping"
                    );
                    return;
                } else if (
                    audioElement.canPlayType &&
                    audioElement.canPlayType(c.mimeType)
                ) {
                    LOG.info(
                        "Client can natively play " +
                            c.mimeType +
                            ", formatId=" +
                            c.formatId
                    );
                    supportedFormats.push(c);
                }
            });
        }

        //Fallback to wav if nothing else works
        if (supportedFormats.length === 0) {
            const c = { mimeType: "audio/wav", formatId: "wav", native: false };
            LOG.info(
                "No natively playable mimeTypes found, using " +
                    c.mimeType +
                    ", formatId=" +
                    c.formatId
            );
            supportedFormats.push(c);
        }

        this.acceptedAudioFormats = supportedFormats;

        return supportedFormats;
    },
    getSuggestedMimeType: function () {
        return this.probeNativeAudioSupport().mimeType;
    },
    getSuggestedFormatId: function () {
        return this.probeNativeAudioSupport().formatId;
    },
    getAllAcceptedMimeTypes: function () {
        const acceptedMimeTypes = this.probeNativeAudioSupportV2();
        return acceptedMimeTypes.length
            ? acceptedMimeTypes.map((x) => x.mimeType)
            : [];
    },
    getAllAcceptedFormatIds: function () {
        const acceptedFormatIds = this.probeNativeAudioSupportV2();
        return acceptedFormatIds.length
            ? acceptedFormatIds.map((x) => x.formatId)
            : [];
    },
    getIsNativeFormatAvailable: function () {
        return this.probeNativeAudioSupport().native;
    },
    shouldSuggestWebm: function () {
        // This webm codec only works for IE, but detecting IE is hard.
        // Since we know that all other browsers we support work with
        // webm or wav, suggest webm codec in all other cases (IE).
        return !this.getIsNativeFormatAvailable();
    },
};

export default ininAudioUtils;
